// Échappement HTML et assainissement des identifiants recopiés dans le HTML.
// Une tâche vient du serveur, ou d'un fichier de planning qu'on importe — un fichier que quelqu'un d'autre a pu
// écrire. Ses identifiants sont recopiés dans des attributs de gestionnaires inline partout dans le site : un identifiant
// contenant une apostrophe en sortirait et ferait exécuter ce qu'il veut. On ne garde donc que des caractères sans
// pouvoir, et on force les champs texte à être des chaînes (le rendu les échappe ensuite). Un lien audio ne peut
// être que http(s) : pas de javascript:.
window.idSur = function(v) { return String(v == null ? '' : v).replace(/[^A-Za-z0-9_.:\-]/g, '').slice(0, 80); };
window.lienSur = function(u) { u = String(u == null ? '' : u).trim(); return /^https?:\/\//i.test(u) ? u.slice(0, 2000) : ''; };

window.escapeHtml = function(str) {
    return (str || '').toString().replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const idSur = window.idSur;
export const lienSur = window.lienSur;
export const escapeHtml = window.escapeHtml;

// ---------------------------------------------------------------- gabarit HTML auto-échappé
// html`<b>${valeur}</b>` échappe chaque valeur ; brut(fragment) marque un HTML déjà sûr (sortie d'un autre
// gabarit, contenu riche filtré) ; un tableau de fragments se concatène. Le résultat est un Brut : il se glisse
// dans un autre gabarit sans double échappement, et innerHTML l'accepte tel quel (toString).
function Brut(s) { this.s = s; }
Brut.prototype.toString = function() { return this.s; };
export function brut(s) { return s instanceof Brut ? s : new Brut(s == null ? '' : String(s)); }
function rendre(v) {
    if (v == null || v === false) return '';
    if (v instanceof Brut) return v.s;
    if (Array.isArray(v)) return v.map(rendre).join('');
    return window.escapeHtml(String(v));
}
export function html(morceaux) {
    var out = '';
    for (var i = 0; i < morceaux.length; i++) { out += morceaux[i]; if (i < arguments.length - 1) out += rendre(arguments[i + 1]); }
    return new Brut(out);
}
// Arguments d'une action, sérialisés pour data-args (JSON échappé : plus d'apostrophes à protéger à la main).
// Le résultat est un Brut : glissé dans html`data-args="${attr([id])}"`, il n'est pas échappé une seconde fois
// (sinon le navigateur lit [&quot;…&quot;], JSON.parse échoue et l'action reçoit le bouton à la place de l'id).
export function attr(v) { return brut(window.escapeHtml(JSON.stringify(v))); }
window.html = html; window.brut = brut; window.attrJson = attr;
